import AuthorInput from './author-input';

export default AuthorInput;
